import { useState, useEffect } from "react";
import "./ClientTable.css";

export default function ClientForm({ onSubmit, client }) {
  const initialForm = {
    nom: "",
    telephone: "",
    email: "",
    adresse: "",
  };

  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (client) {
      setForm(client);
    } else {
      setForm(initialForm);
    }
  }, [client]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await onSubmit(form);

      // Vider le formulaire après succès
      setForm(initialForm);

    } catch (error) {
      console.error(error);
    }
  };

  return (
    <form className="client-form" onSubmit={handleSubmit}>
      <input 
        name="nom" 
        placeholder="Nom" 
        onChange={handleChange} 
        value={form.nom} 
      />

      <input 
        name="telephone" 
        placeholder="Téléphone" 
        onChange={handleChange} 
        value={form.telephone} 
      />

      <input 
        name="email" 
        placeholder="Email" 
        onChange={handleChange} 
        value={form.email} 
      />

      <input 
        name="adresse" 
        placeholder="Adresse" 
        onChange={handleChange} 
        value={form.adresse} 
      />

      <button type="submit">
        Enregistrer
      </button>
    </form>
  );
}